module.exports = __webpack_public_path__ + "static/media/X_Icon.ea6a70d7.svg";